<template>
  <v-data-table
    v-model="selecteds"
    :headers="headers"
    :items="grades"
    item-key="title"
    show-select
    class="elevation-1"
    :footer-props="{ 'items-per-page-text': 'Số khối một trang', 'items-per-page-all-text': 'Tất cả' }"
  >
    <template v-slot:[`footer.page-text`]="items">
      {{ items.pageStart }} - {{ items.pageStop }} trên tổng
      {{ items.itemsLength }}
    </template>
    <div slot="top">
      <div class="d-flex justify-space-between ps-4 py-2">
        <span :class="selecteds.length ? 'text--primary' : 'text--disabled'">{{
          selecteds.length ? 'Đã chọn ' + selecteds.length + ' khối' : 'Chưa chọn'
        }}</span>
        <v-btn
          class="mr-4"
          small
          color="primary"
          :disabled="!selecteds.length"
          @click="$emit('sendPost', { grades: selecteds })"
        >
          Gửi tin nhắn
        </v-btn>
      </div>
    </div>
  </v-data-table>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  data() {
    return {
      selecteds: [],
      grade: null,
      headers: [
        { text: 'Nhóm nhận tin', value: 'title' },
        { text: 'Số lớp', value: 'classNo' },
        { text: 'Số học sinh', value: 'studentNo' }
      ]
    }
  },
  async mounted() {
    this.$loading.active = true
    await this.fetchGradeData()
    this.$loading.active = false
  },
  computed: {
    ...mapGetters('postCreate', ['allSchoolItems']),
    ...mapState('postCreate', ['grades', 'sendPostResult'])
  },
  methods: {
    ...mapActions('postCreate', ['fetchGradeData'])
  },
  watch: {
    sendPostResult: {
      handler(val) {
        if (val && val.isSuccess) {
          this.selecteds = []
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>
